angular.module('homebot.directives')

  .directive('refiSection', ['Dictionary', function(Dictionary){
    return {
      restrict: 'A',
      controllerAs: 'refiCtrl',
      bindToController: {
        agent: '=',
        loans: '=',
        company: '=',
        homeId: '@',
        userId: '@',
      },
      scope: {},
      templateUrl: '/homes/templates/section-refi.html',

      controller: function(){
        var dictionary = new Dictionary();
        var ctrl = this;

        ctrl.lookup = function(prop,args,home){
          var home = {
            loans: _.isArray(ctrl.loans) ? ctrl.loans : [ctrl.loans],
            agent: [ctrl.agent]
          };
          return dictionary[prop](home,args);
        };
      }
    }
  }]);
